<template>
  <div class="your_place_wrap">
    <div class="your_place your_subway map_select" @click.prevent.stop="toggleSelect">
      <span class="map_select_selected">
        <slot>
          {{ selectedName }}
        </slot>
      </span>
      <div class="select_list_wrap" :style="{display: isOpened ? '' : 'none'}">
        <div class="select_list" ref="list">
          <div v-for="[value, name] in options" :key="value">
            <a href="#" :class="{active: value === value}" @click.prevent="handleSelect(value)">
              {{ name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      options: {
        validator: (value) => value instanceof Map || typeof value === 'object'
      },
      value: {
        type: String,
        default: '',
      },
    },
    data: () => {
      return {
        isOpened: false
      }
    },
    computed: {
      selectedName() {
        return this.value !== undefined
            ? this.options instanceof Map ? this.options.get(this.value) : this.options[this.value]
            : '';
      }
    },
    methods: {
      mounted() {
        if (!(this.options instanceof Map)) {
          this.options = new Map(Object.entries(this.options));
        }
      },
      toggleSelect() {
        this.isOpened = !this.isOpened;
      },
      handleSelect(value) {
        this.$emit('input', value);
      }
    }
  }
</script>
<style>
.select_list_wrap {
  padding: 5px 9px 5px 0;
}
.select_list {
  overflow: auto;
}
.select_list::-webkit-scrollbar {
  width:10px;
}
.select_list::-webkit-scrollbar-track {
  background:#dedad7;
}
.select_list::-webkit-scrollbar-thumb {
  border-radius: 0;
  background:#9e7c61;
}
</style>
